export default __webpack_public_path__ + "static/media/store.39292ba0.png";